import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, Shield, CreditCard, FileText, Flag } from 'lucide-react';
export function FinalCTA() {
  const trustBadges = [{
    icon: <Lock className="w-4 h-4" data-id="element-81" />,
    text: 'Pago 100% seguro'
  }, {
    icon: <Zap className="w-4 h-4" data-id="element-82" />,
    text: 'Acceso en 5 minutos'
  }, {
    icon: <Shield className="w-4 h-4" data-id="element-83" />,
    text: 'Garantía 7 días'
  }, {
    icon: <CreditCard className="w-4 h-4" data-id="element-84" />,
    text: 'Mercado Pago · Tarjeta · Transferencia'
  }, {
    icon: <FileText className="w-4 h-4" data-id="element-85" />,
    text: '100% PDF'
  }, {
    icon: <Flag className="w-4 h-4" data-id="element-86" />,
    text: 'Hecho en Argentina'
  }];
  return <section className="w-full bg-[#0a1410] py-8 md:py-16" data-id="element-87">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-89">
          {/* Pricing Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 max-w-5xl mx-auto mb-6 md:mb-12" data-id="element-90">
            {/* Premium Pack */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-[#0f1f17] border-2 border-amber-500 rounded-lg p-8 relative" data-id="element-91">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-amber-500 text-white text-xs font-bold px-4 py-1 rounded-full" data-id="element-92">
                ⭐ MÁS POPULAR
              </div>
              <h4 className="text-2xl font-bold text-white mb-2" data-id="element-93">
                🏆 ATLAS + MÉTODO BLINDAJE TOTAL
              </h4>
              <p className="text-amber-500 font-semibold mb-4" data-id="element-94">
                6 Tomos + 3 Bonos + Manual Maestro Método Blindaje Total, cadera
                y tobillo
              </p>
              <div className="mb-6" data-id="element-95">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-96">
                  <span className="text-gray-500 line-through text-xl" data-id="element-97">
                    $65.000
                  </span>
                  <span className="text-amber-500 font-bold text-4xl" data-id="element-98">
                    $19.990
                  </span>
                  <span className="text-gray-400" data-id="element-99">ARS</span>
                </div>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48149631860928:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-amber-500 hover:bg-amber-600 text-white font-bold text-lg px-6 py-4 rounded-lg transition-colors shadow-lg shadow-amber-500/20 text-center" data-id="element-100">
                🔴 → QUIERO EL ATLAS + BLINDAJE TOTAL
              </motion.a>
              <motion.a href="https://pay.hotmart.com/U105426122X?checkoutMode=10" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-transparent border-2 border-amber-500 hover:bg-amber-500/10 text-amber-500 font-bold text-base px-6 py-3 rounded-lg transition-colors text-center mt-3" data-id="element-101">
                💳 ¿Problemas con Mercado Pago? Pagá acá
              </motion.a>
              <p className="text-xs text-gray-500 text-center mt-1.5" data-id="element-102">
                Mismo producto · Medio de pago alternativo
              </p>
            </motion.div>

            {/* Basic Pack */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1,
            duration: 0.5
          }} className="bg-[#0f1f17] border border-amber-900/30 rounded-lg p-8" data-id="element-103">
              <h4 className="text-2xl font-bold text-white mb-2" data-id="element-104">
                📘 ATLAS DE LA RODILLA
              </h4>
              <p className="text-amber-500 font-semibold mb-4" data-id="element-105">
                6 Tomos + 3 Bonos · Evaluación → Retorno Deportivo
              </p>
              <div className="mb-6" data-id="element-106">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-107">
                  <span className="text-gray-500 line-through text-xl" data-id="element-108">
                    $47.000
                  </span>
                  <span className="text-amber-500 font-bold text-4xl" data-id="element-109">
                    $15.990
                  </span>
                  <span className="text-gray-400" data-id="element-110">ARS</span>
                </div>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48149627371712:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-amber-500 hover:bg-amber-600 text-white font-bold text-lg px-6 py-4 rounded-lg transition-colors shadow-lg shadow-amber-500/20 text-center" data-id="element-111">
                🔴 → QUIERO MI ATLAS
              </motion.a>
              <motion.a href="https://pay.hotmart.com/U105426122X?checkoutMode=10" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-transparent border-2 border-amber-500 hover:bg-amber-500/10 text-amber-500 font-bold text-base px-6 py-3 rounded-lg transition-colors text-center mt-3" data-id="element-112">
                💳 ¿Problemas con Mercado Pago? Pagá acá
              </motion.a>
              <p className="text-xs text-gray-500 text-center mt-1.5" data-id="element-113">
                Mismo producto · Medio de pago alternativo
              </p>
            </motion.div>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-1.5 md:gap-3 items-center justify-center" data-id="element-114">
            {trustBadges.map((badge, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.3
          }} className="flex items-center gap-1 md:gap-2 bg-[#0f1f17] border border-amber-900/30 rounded-full px-2 py-1 md:px-4 md:py-2" data-id="element-115">
                <span className="text-amber-500 [&>svg]:w-3 [&>svg]:h-3 md:[&>svg]:w-4 md:[&>svg]:h-4" data-id="element-116">
                  {badge.icon}
                </span>
                <span className="text-[10px] md:text-sm text-gray-300 font-medium leading-tight" data-id="element-117">
                  {badge.text}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}